import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {VisibleTypes} from './';
import Select from 'react-select';

class FieldSetup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      advanced : false,
      minWidthType : 'px', //percent or px
    }
    this.handleChange = this.handleChange.bind(this);
    this.addOption = this.addOption.bind(this);
    this.removeOption = this.removeOption.bind(this);
  }
  handleChange(event, index) {
    const field = {...this.props.field};
    const value = event.target.value;
    const names = event.target.name.split('.');
    const name = names[0];
    switch(name) {
      case 'flex':case 'order':
        field[name] = Number(value);
        break;
      case 'label':
        field[name] = (value.match(/([a-zA-Z0-9]| )+/g) || []).join(' ');
        field['name'] = `${value.slice(0,7) != 'custom_'? 'custom_' : ''}${(value.match(/[a-zA-Z0-9]+/g) || []).join('_').toLowerCase()}`
        break;
      case 'name':
        if(value.slice(0,6) == 'custom' && value.length == 6) {
          break;
        }

        let curr_name = (value.replace(' ','_').match(/([a-zA-Z0-9]|_)+/g) || []).join('_');
        field['name'] = `${curr_name.slice(0,7) != 'custom_' ? `custom_${curr_name}` : curr_name}`;
        // field['name'] = `${value.slice(0,8) != 'custom_'? 'custom_' : ''}${(value.slice(8,value.length).match(/[a-zA-Z0-9]+/g) || []).join('_').toLowerCase()}`
        break;
      case 'option':
        const index = Number(names[1]);
        const options = field.options[index];
        if(!options)
          field.options[index] = {};
        // field.options[index][names[2]] = value;
          field.options[index]['value'] = value;
          field.options[index]['label'] = value;
        break;
      case 'show_with_details':
        field[name] = value == 'true'? true : false;
        break;
      default:
          field[name] = value;
          break;
    }

    this.props.onChange(field)
  }
  addOption(index) {
    const field = {...this.props.field};
    index = index || 0;
    field.options = [...field.options.slice(0, index+1),{label : '', value : ''},...field.options.slice(index+1, field.options.length)];
    this.props.onChange(field);
  }
  removeOption(index) {
    const field = {...this.props.field};
    field.options = [...field.options.slice(0,index), ...field.options.slice(index+1,field.options.length)];
    this.props.onChange(field);
  }
  render() {
    if(!this.props.field) {
      return <div></div>;
    }

    return <div className="field-setup">
      <div className="form">

        <div className="input-group mb-sm">
          <label className="input-group-addon">Type</label>
          <select name="type" className={"form-control "} onChange={this.handleChange} value={this.props.field.type}>
            {VisibleTypes.map((type,i) => (
              <option key={i} value={type[0]}>{type[1]}</option>
            ))}
          </select>
          <label className="input-group-addon"><i className={`fa fa-${VisibleTypes.find(type => (type[0] == this.props.field.type))[2]}`}></i></label>
        </div>
        {this.props.field.type == 'relationship' ? (
          <div className='row mb-sm'>
            <div className='col-xs-12'>
              <div style={{zIndex:1000}} className="input-group">
                <label className="input-group-addon"><i className="fa fa-cogs"></i> References: </label>
                <Select
                  style={{borderRadius: 0,zIndex:1000}}
                  options={[{label: 'Client', value: 'Client'}]}
                  placeholder='Select a relationship type.'
                  value={this.props.field.entity_ref}
                  onChange={(data) => this.props.onChange({...this.props.field, entity_ref: data ? data.value : ''})}
                />
              </div>
            </div>
          </div>
        ) : null}
        <div className="input-group mb-sm">
          <label className="input-group-addon">Group</label>
          <input className="form-control" type="text" name="group" placeholder="Enter a field group name." onChange={this.handleChange} value={this.props.field.group} />
        </div>
        <div className="input-group mb-sm">
          <label className="input-group-addon">Label</label>
          <input className="form-control" type="text" name='label' placeholder="Enter a label." onChange={this.handleChange} value={this.props.field.label} />
        </div>
        {/* <div className="input-group mb-sm">
          <label className="input-group-addon">Name</label>
          <input className="form-control" type="text" name='name' placeholder="Enter a name. (Used in the API)" onChange={this.handleChange} value={this.props.field.name} />
        </div> */}
        <div className="input-group mb-sm">
          <label className="input-group-addon">Placeholder</label>
          <input className="form-control" type="text" name='placeholder' placeholder="Enter a placeholder. (Seen in field background)" onChange={this.handleChange} value={this.props.field.placeholder} />
        </div>
        <div className="input-group mb-sm">
          <label className="input-group-addon"><i className="fa fa-eye"></i></label>
          <select className="form-control" onChange={this.handleChange} name="show_with_details" value={this.props.field.show_with_details}>
            <option>Choose view option.</option>
            <option value={false}>Display only on {this.props.type}'s view.</option>
            <option value={true}>Display everywhere.</option>
          </select>
        </div>
        <div className="input-group mb-sm">
          <label className="input-group-addon">Order</label>

            <div className='form-control'>{this.props.field.order}</div>
            <div className="input-group-btn">
              <div onClick={event => this.props.onChange({...this.props.field, order: this.props.field.order-1})} className='btn btn-default'><i className="fa fa-arrow-up"></i></div>
              <div onClick={event => this.props.onChange({...this.props.field, order: this.props.field.order+1})} className='btn btn-default'><i className="fa fa-arrow-down"></i></div>
            </div>

          {/* <input className="form-control" type="number" name="order" placeholder="Choose a flex number." onChange={this.handleChange} value={this.props.field.order} /> */}
        </div>
        <div className="input-group mb-sm">
          <label className="input-group-addon"><i className="fa fa-percent"></i></label>
          {/* <input className="form-control" type="text" name="minWidth" placeholder="Enter a width % or px." onChange={this.handleChange} value={this.props.field.minWidth} /> */}
          <select className="form-control" onChange={this.handleChange} name="flex" value={this.props.field.flex}>
            <option>Choose a width.</option>
            <option value={3}>1/4 Width</option>
            <option value={4}>1/3 Width</option>
            <option value={6}>1/2 Width</option>
            <option value={8}>2/3 Width</option>
            <option value={9}>3/4 Width</option>
            <option value={12}>Full Width</option>
          </select>

        </div>

        {/* {this.state.advanced ? (
          <div>
            <div className="input-group mb-sm">
              <label className="input-group-addon">Flex</label>
              <input className="form-control" type="number" name="flex" placeholder="Choose how much space this field takes." onChange={this.handleChange} value={this.props.field.flex} />
            </div>
            <div className="input-group mb-sm">
              <label className="input-group-addon">Width</label>
              <input className="form-control" type="text" name="minWidth" placeholder="Enter a width % or px." onChange={this.handleChange} value={this.props.field.minWidth} />
            </div>
          </div>
        ) : (
          <div className="col-xs-12">
          <div className="pull-right mb-lg"><a href="#" onClick={e => {
            e.preventDefault();
            this.setState({advanced : !this.state.advanced});
          }}>Advanced</a></div>
          </div>
        )} */}
        {this.props.field.type == 'multiselect' || this.props.field.type == 'select' ? (
          <div className="row">
            <div className="col-xs-12">
              <h6>Options</h6>
            </div>
            <div className="col-xs-12">
                {this.props.field.options.length == 0 ? <div onClick={e => this.addOption(0)} className="btn btn-block btn-success"><i className="fa fa-plus"></i> Add Option</div> : ''}
                {this.props.field.options.slice(0, this.props.field.options.length + 1).map((option, index) => (
                  <div key={index} className="mb-sm">
                    <label className="control-label">Name</label>
                    <input className="form-control" onChange={this.handleChange} placeholder="Name" type="text" name={`option.${index}.label`} value={option? (option.label || '') : ''} />
                    {/* <label className="control-label">Value</label>
                    <input className="form-control" onChange={this.handleChange} placeholder="Value" type="text" name={`option.${index}.value`} value={option? (option.value || '') : ''} /> */}
                    <div className="btn-group mt-sm">
                        <div onClick={e => this.removeOption(index)} className="btn btn-danger"><i className="fa fa-minus"></i></div>
                        <div onClick={e => this.addOption(index)} className="btn btn-success"><i className="fa fa-plus"></i></div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="col-xs-12">
              <hr className="separator" />
            </div>
          </div>
        ) : ''}
        <div className="row">
          {this.props.onDelete ? (
            <div className="col-xs-12 col-md-4">
              <div onClick={e => this.props.onDelete({...this.props.field})} className="btn btn-block btn-danger"><i className="fa fa-trash"></i> Delete</div>
            </div>
          ) : ''}
          {this.props.onCancel ? (
            <div className={'col-xs-12 col-sm-6 col-md-4 ' +  classNames({'col-md-offset-4' : !this.props.onDelete})}>
              <div onClick={this.props.onCancel} className="btn btn-block btn-default">{this.props.onChange ? 'Close' : 'Cancel'}</div>
            </div>
          ): ''}
          {this.props.onChange && !this.props.onSave ? '' : (
            <div className="col-xs-12 col-sm-6 col-md-4">
              <div onClick={e => this.props.onSave({...this.props.field})} className="btn btn-block btn-success">Save</div>
            </div>
          )}
        </div>
      </div>
    </div>
  }
}

FieldSetup.propTypes = {
  field : PropTypes.object.isRequired,
  field_prototype : PropTypes.object,
  onCancel : PropTypes.func.isRequired,
  onSave : PropTypes.func.isRequired,
  onChange : PropTypes.func,
  onDelete : PropTypes.func,
}

export default FieldSetup;



// WEBPACK FOOTER //
// ./src/browser/components/form-builder/field-setup.js